import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
(function(){
  const addToCartPriceEls = document.querySelectorAll('.mrk-price-btn');
  const subscriptionPriceEls = document.querySelectorAll('.mrk-main-price');
  const onetimePriceEls = document.querySelectorAll('.mrk-onetime-price');
  const compareAtPriceEls = document.querySelectorAll('.compare-at-price');
  const subscribeCheckbox = document.querySelector('.md-subscribe-input');
  const sellingPlan = document.querySelector('[name="selling_plan"]');

  function updatePrice(){
    const r = document.querySelector('.md-pk-radio:checked');
    if(!r) return;

    const base = Number(r.getAttribute('base-price')) || 0;
    const onetimePrice = r.getAttribute('price') || ''; // Pack price without subscription discount

    // Get pack size and base compare-at-price for calculating compare-at-price
    const packSize = Number(r.getAttribute('data-pack-size')) || 1;
    const baseCompareAtPrice = Number(r.getAttribute('data-base-compare-at-price')) || 0;
    const baseVariantPrice = Number(r.getAttribute('data-base-variant-price')) || 0;

    // Calculate subscription price (always apply subscription discount for Subscribe section)
    let subscriptionPrice = onetimePrice;
    if(sellingPlan && sellingPlan.selectedOptions.length){
      const d = Number(sellingPlan.selectedOptions[0].getAttribute('discount')) || 0;
      const discountEl = document.querySelector('.mrk-subscription-discount');
      if(discountEl) discountEl.innerHTML = d;
      const discounted = (base * (1 - d/100)) / 100;
      subscriptionPrice = (window.cart_currency || '') + discounted.toFixed(2);
    }

    // Subscribe section always shows subscription-discounted price
    subscriptionPriceEls.forEach(el => el.innerHTML = subscriptionPrice);

    // One-time section always shows pack price without subscription discount
    onetimePriceEls.forEach(el => el.innerHTML = onetimePrice);

    // Add to Cart button shows price based on which option is selected
    const isSubscriptionSelected = subscribeCheckbox && subscribeCheckbox.checked;
    const addToCartPrice = isSubscriptionSelected ? subscriptionPrice : onetimePrice;
    addToCartPriceEls.forEach(el => el.innerHTML = addToCartPrice);

    // Update compare-at-price based on pack size
    if(baseCompareAtPrice > 0) {
      const totalCompareAtPrice = (baseCompareAtPrice * packSize) / 100;
      const formattedCompareAtPrice = (window.cart_currency || '$') + totalCompareAtPrice.toFixed(0);
      compareAtPriceEls.forEach(el => el.innerHTML = formattedCompareAtPrice);
    }

    // Calculate and display crossed-out price (base price × quantity)
    const crossoutPrice = (baseVariantPrice * packSize) / 100;
    const formattedCrossoutPrice = (window.cart_currency || '$') + crossoutPrice.toFixed(2);

    // Subscription crossed-out prices (always show, regardless of selection)
    const subscriptionCrossoutEls = document.querySelectorAll('.md-subscription-single-card .mrk-crossout-price');
    subscriptionCrossoutEls.forEach(el => {
      el.style.display = '';
      el.innerHTML = formattedCrossoutPrice;
    });

    // One-time crossed-out prices (only show when pack size > 1)
    const onetimeCrossoutEls = document.querySelectorAll('.md-onetime-card .mrk-crossout-price');
    onetimeCrossoutEls.forEach(el => {
      el.style.display = packSize > 1 ? '' : 'none';
      el.innerHTML = formattedCrossoutPrice;
    });
  }

  document.addEventListener('change', e => {
    if(e.target.matches('.md-checkbox-input, [name="selling_plan"], .md-pk-radio')) updatePrice();
  });

  document.addEventListener('DOMContentLoaded', updatePrice);
})();
